import styled from 'styled-components';
import type {TicketStatus} from '../types/ticket';
import type {TicketingTokens} from '../../../styles/tokens';

type ColorToken = keyof TicketingTokens['color'];

const STATUS_BG: Record<TicketStatus, ColorToken> = {
	open: 'statusOpenBg',
	in_progress: 'statusInProgressBg',
	waiting_on_customer: 'statusWaitingBg',
	resolved: 'statusResolvedBg',
	closed: 'statusClosedBg',
};
const STATUS_TEXT: Record<TicketStatus, ColorToken> = {
	open: 'statusOpenText',
	in_progress: 'statusInProgressText',
	waiting_on_customer: 'statusWaitingText',
	resolved: 'statusResolvedText',
	closed: 'statusClosedText',
};
const STATUS_DOT: Record<TicketStatus, string> = {
	open: '#3b82f6',
	in_progress: '#eab308',
	waiting_on_customer: '#f97316',
	resolved: '#22c55e',
	closed: '#64748b',
};
const STATUS_LABELS: Record<TicketStatus, string> = {
	open: 'Open',
	in_progress: 'In progress',
	waiting_on_customer: 'Waiting on customer',
	resolved: 'Resolved',
	closed: 'Closed',
};

const Badge = styled.span<{$status: TicketStatus}>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 2px 10px;
	border-radius: ${p => p.theme.ticketing.radius.xs};
	font: ${p => p.theme.ticketing.font.body3};
	font-weight: 500;
	background: ${p => p.theme.ticketing.color[STATUS_BG[p.$status]]};
	color: ${p => p.theme.ticketing.color[STATUS_TEXT[p.$status]]};
`;
const Dot = styled.span<{$status: TicketStatus}>`
	width: 6px;
	height: 6px;
	border-radius: ${p => p.theme.ticketing.radius.full};
	background: ${p => STATUS_DOT[p.$status]};
`;

interface Props {
	status: TicketStatus;
}

export function TicketStatusBadge({status}: Props) {
	return (
		<Badge $status={status}>
			<Dot $status={status} aria-hidden="true" />
			{STATUS_LABELS[status]}
		</Badge>
	);
}
